import { render, staticRenderFns } from "./quickChild.vue?vue&type=template&id=0cd3d506&scoped=true&"
import script from "./quickChild.vue?vue&type=script&lang=js&"
export * from "./quickChild.vue?vue&type=script&lang=js&"
import style0 from "./quickChild.vue?vue&type=style&index=0&id=0cd3d506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd3d506",
  null
  
)

export default component.exports